import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Table, Divider, Button, Input, message, Spin } from "antd";
import { MinusSquareOutlined, SearchOutlined } from "@ant-design/icons";
import {
  convertDeviceList,
  convertDependentDeviceListToApiValues,
} from "../../Helpers/DeviceHelpers";
import { apiCallback } from "../../ApiHandlers/Common";
import { defaultSort } from "../../Constants/Utilities";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class DeviceUnassign extends React.Component {
  constructor(props) {
    super(props);
    console.log("DeviceUnassign props", props);
    this.state = {
      deviceData: [],
      filteredDeviceData: [],
      fetchingDeviceData: false,
      processing: false,
      selectedRows: [],
      columns: [
        {
          title: "Device Id",
          dataIndex: "deviceId",
          sorter: (a, b) => defaultSort(a.deviceId, b.deviceId),
          defaultSortOrder: "ascend",
        },
        {
          title: "Device Model",
          dataIndex: "modelNumber",
          sorter: (a, b) => defaultSort(a.modelNumber, b.modelNumber),
        },
        {
          title: "Base MAC Address",
          dataIndex: "baseMacAddress",
        },
        {
          title: "Software Version",
          dataIndex: "softwareVersion",
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchDeviceData();
  }

  /* fetch unassgined devices for given model */
  fetchDeviceData() {
    console.log("fetchDeviceData...");
    const errorCallback = (error) => {
      this.setState({ fetchingDeviceData: false });
      message.error("Error fetching Device list!");
    };
    const successCallback = (data) => {
      const deviceData = convertDeviceList(data);
      console.log("fetchDeviceData data", deviceData);
      this.setState({
        deviceData,
        fetchingDeviceData: false,
        filteredDeviceData: deviceData,
      });
    };
    try {
      this.setState({ fetchingDeviceData: true });
      const { history, record, deviceApi } = this.props;
      deviceApi.getDeviceByProviderId(
        record.providerId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  }

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { deviceData } = this.state;
    let filteredDeviceData = deviceData;
    if (!!text) {
      filteredDeviceData = deviceData.filter((item) =>
        item.deviceId.toLowerCase().includes(text.toLowerCase())
      );
    }
    this.setState({ filteredDeviceData });
  };

  onDeviceUnassign = () => {
    const errorCallback = (error) => {
      this.setState({ processing: false });
      message.error("Error unassigning Devices!");
    };
    const successCallback = (data) => {
      message.success("Devices unassinged successfully!");
      this.setState({ processing: false, selectedRows: [] });
      this.fetchDeviceData(); /* refetch unassigned device */
    };
    try {
      this.setState({ processing: true });
      const { selectedRows } = this.state;
      console.log("onDeviceUnassign...", selectedRows);
      const { record, history, serviceProviderApi } = this.props;
      const deviceData = convertDependentDeviceListToApiValues(selectedRows);
      console.log("onDeviceUnassign deviceData", deviceData);
      serviceProviderApi.unAssignDevicesToServiceProvider(
        record.providerId,
        deviceData,
        apiCallback({
          history,
          errorCallback,
          failCallback: errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  render() {
    const {
      columns,
      processing,
      selectedRows,
      fetchingDeviceData,
      filteredDeviceData,
    } = this.state;
    const { record, onActionClick, parentBread } = this.props;
    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread.concat(`Unassign Device`)}
            onParentActionClick={onActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="page-parent-title-container">
          <label>Service Provider: {record.name}</label>
        </div>
        <Spin spinning={processing} tip="Assigning Devices, please wait...">
          <div className="search-add-container">
            <div className="search-container">
              <span className="search-label">Search:</span>
              <Input
                allowClear
                className="search-input"
                placeholder="Enter Device ID"
                onChange={this.onSerchTextChange}
                suffix={<SearchOutlined style={{ fontSize: 16 }} />}
              />
            </div>
            <div className="add-container">
              <Button
                type="primary"
                icon={<MinusSquareOutlined />}
                onClick={this.onDeviceUnassign}
                disabled={!selectedRows.length}
                title={
                  selectedRows.length
                    ? `Unassign ${selectedRows.length} Devices`
                    : "Select Devices to Unassign"
                }
              >
                Unassign ({selectedRows.length})
              </Button>
            </div>
          </div>
          <Table
            bordered
            size="small"
            columns={columns}
            dataSource={filteredDeviceData}
            className="entity-table"
            loading={fetchingDeviceData && { tip: "Fetching Device list..." }}
            rowSelection={{
              onChange: (_, selectedRows) => this.setState({ selectedRows }),
              getCheckboxProps: (record) => ({
                name: record.name,
                disabled: false,
              }),
            }}
          />
        </Spin>
      </div>
    );
  }
}

DeviceUnassign.propTypes = {
  record: PropTypes.object,
  onActionClick: PropTypes.func,

  deviceApi: PropTypes.object,
  serviceProviderApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deviceApi: state.apis.deviceApi,
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedDeviceUnassign = connect(mapStateToProps)(DeviceUnassign);
export default withRouter(connectedDeviceUnassign);
